import { useEffect, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Home from './pages/Home';
const Blog = lazy(() => import('./pages/Blog'));
const BlogPost = lazy(() => import('./pages/BlogPost'));
import WhatsAppButton from './components/WhatsAppButton';
import DemoRequest from './pages/DemoRequest';
import Features from './pages/Features';
import Pricing from './pages/Pricing';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import AboutPage from '@/pages/About';
import UsageGuide from '@/pages/UsageGuide';
import GizlilikPolitikasi from './pages/GizlilikPolitikasi';

// Rota değişince kullanıcıyı her zaman sayfanın başına al (anında, smooth değil).
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Suspense
          fallback={
            <div role="status" className="p-10 text-center text-ink-muted">
              Sayfa yükleniyor…
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/ozellikler" element={<Features />} />
            <Route path="/demo" element={<DemoRequest />} />
            <Route path="/fiyatlar" element={<Pricing />} />
            <Route path="/hakkimizda" element={<AboutPage />} />
            <Route path="/iletisim" element={<Contact />} />
            <Route path="/nasil-kullanilir" element={<UsageGuide />} />
            <Route path="/gizlilik-politikasi" element={<GizlilikPolitikasi />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <WhatsAppButton />
      </Router>
    </HelmetProvider>
  );
}

export default App;
